import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

interface BackdropStylesProps {
  backdropColor?: string;
}

export const BackdropStyles = makeStyles<BackdropStylesProps>()((theme: Theme, props) => ({
  backdropBgColor: {
    backgroundColor: props.backdropColor,
    zIndex: 10,
  },
}));
